var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wmt-topBg',{attrs:{"src":_vm.topImg}}),_c('wmt-contactDetail'),_c('wmt-map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }